import React from "react";

const MyAccount = () => {
  return (
    <div className="container">
      <p>My account view</p>
    </div>
  );
};

export default MyAccount;